// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings { min-height: 100vh; background: var(--bg); }
.settings-state { padding: 80px 20px; text-align: center; color: var(--muted); font-size: 14px; }
.settings-body { padding: 36px 40px 80px; max-width: 720px; }
.settings-h1 { font-size: 22px; font-weight: 700; letter-spacing: -.02em; color: var(--ink); margin-bottom: 24px; }

.set-card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 22px;
  margin-bottom: 18px;
}
.set-card--danger { border-color: rgba(248, 81, 73, .35); }
.set-card__title {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -.01em;
  color: var(--ink);
  margin-bottom: 14px;
}

.set-avatar-row { display: flex; align-items: center; gap: 16px; margin-bottom: 18px; }
.set-avatar {
  width: 72px; height: 72px; border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--teal);
}

.set-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: .08em;
  color: var(--muted);
  text-transform: uppercase;
  margin-top: 12px;
  margin-bottom: 6px;
}

.set-input, .set-textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--bg);
  color: var(--ink);
  font-size: 13px;
  font-family: inherit;
  box-sizing: border-box;
  transition: border-color .15s;
}
.set-input:focus, .set-textarea:focus { outline: none; border-color: var(--teal); }
.set-textarea { resize: vertical; min-height: 72px; }

.set-hint { font-size: 11px; color: var(--muted); margin-top: 4px; margin-bottom: 12px; }

.set-msg {
  font-size: 12px;
  padding: 8px 12px;
  border-radius: 8px;
  margin: 12px 0;
}
.set-msg--ok  { background: rgba(69, 230, 194, .12); color: var(--teal-dark); }
.set-msg--err { background: rgba(248, 81, 73, .12); color: #c93a32; }

.btn-outline {
  background: var(--surface);
  border: 1px solid var(--line);
  color: var(--ink);
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color .15s, color .15s;
}
.btn-outline:hover { border-color: var(--teal); color: var(--teal); }

.btn-danger {
  background: #f85149;
  color: #fff;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background .15s;
}
.btn-danger:hover { background: #e0463e; }

@media (max-width: 600px) {
  .settings-body { padding: 24px 20px 60px; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Settings.css"],"names":[],"mappings":"AAAA,YAAY,iBAAiB,EAAE,qBAAqB,EAAE;AACtD,kBAAkB,kBAAkB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAChG,iBAAiB,uBAAuB,EAAE,gBAAgB,EAAE;AAC5D,eAAe,eAAe,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;;AAElH;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA,oBAAoB,oCAAoC,EAAE;AAC1D;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACtF;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,6BAA6B;AAC/B;AACA,wCAAwC,aAAa,EAAE,yBAAyB,EAAE;AAClF,gBAAgB,gBAAgB,EAAE,gBAAgB,EAAE;;AAEpD,YAAY,eAAe,EAAE,mBAAmB,EAAE,eAAe,EAAE,mBAAmB,EAAE;;AAExF;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA,gBAAgB,mCAAmC,EAAE,uBAAuB,EAAE;AAC9E,gBAAgB,kCAAkC,EAAE,cAAc,EAAE;;AAEpE;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;AACA,qBAAqB,yBAAyB,EAAE,kBAAkB,EAAE;;AAEpE;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;AACA,oBAAoB,mBAAmB,EAAE;;AAEzC;EACE,iBAAiB,uBAAuB,EAAE;AAC5C","sourcesContent":[".settings { min-height: 100vh; background: var(--bg); }\n.settings-state { padding: 80px 20px; text-align: center; color: var(--muted); font-size: 14px; }\n.settings-body { padding: 36px 40px 80px; max-width: 720px; }\n.settings-h1 { font-size: 22px; font-weight: 700; letter-spacing: -.02em; color: var(--ink); margin-bottom: 24px; }\n\n.set-card {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 22px;\n  margin-bottom: 18px;\n}\n.set-card--danger { border-color: rgba(248, 81, 73, .35); }\n.set-card__title {\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: -.01em;\n  color: var(--ink);\n  margin-bottom: 14px;\n}\n\n.set-avatar-row { display: flex; align-items: center; gap: 16px; margin-bottom: 18px; }\n.set-avatar {\n  width: 72px; height: 72px; border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid var(--teal);\n}\n\n.set-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: .08em;\n  color: var(--muted);\n  text-transform: uppercase;\n  margin-top: 12px;\n  margin-bottom: 6px;\n}\n\n.set-input, .set-textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  background: var(--bg);\n  color: var(--ink);\n  font-size: 13px;\n  font-family: inherit;\n  box-sizing: border-box;\n  transition: border-color .15s;\n}\n.set-input:focus, .set-textarea:focus { outline: none; border-color: var(--teal); }\n.set-textarea { resize: vertical; min-height: 72px; }\n\n.set-hint { font-size: 11px; color: var(--muted); margin-top: 4px; margin-bottom: 12px; }\n\n.set-msg {\n  font-size: 12px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  margin: 12px 0;\n}\n.set-msg--ok  { background: rgba(69, 230, 194, .12); color: var(--teal-dark); }\n.set-msg--err { background: rgba(248, 81, 73, .12); color: #c93a32; }\n\n.btn-outline {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  color: var(--ink);\n  padding: 10px 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: border-color .15s, color .15s;\n}\n.btn-outline:hover { border-color: var(--teal); color: var(--teal); }\n\n.btn-danger {\n  background: #f85149;\n  color: #fff;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background .15s;\n}\n.btn-danger:hover { background: #e0463e; }\n\n@media (max-width: 600px) {\n  .settings-body { padding: 24px 20px 60px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
